import { useContext } from 'react'
import PropTypes from 'prop-types'
import swal from 'sweetalert2'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import { generateRedirectUrl } from '@domain-group/javascript-utils'

import { generateUrls } from '@hooks/usePublication'

import PageContext from '@contexts/pageContext'

const confirmDelete = (updateServiceProduct, togglePublication) => {
  const payload = {
    callbacks: { action: togglePublication },
    toastText: 'Publication Removed',
  }

  swal
    .fire({
      confirmButtonColor: '#DD6B55',
      confirmButtonText: 'Yes, delete it.',
      icon: 'warning',
      showCancelButton: true,
      text: 'Are you sure?',
      title: 'Delete Editorial Publication?',
    })
    .then(({ value }) => {
      if (value){
        updateServiceProduct(payload)
      }
    })
}

const EditorialPublicationListItem = (props) => {
  const {
    callbacks: {
      togglePublication,
    },
    publication,
  } = props

  const { id, title } = publication

  const { callbacks } = useContext(PageContext)
  const { updateServiceProduct } = callbacks || {}

  const { editPublicationUrl } = generateUrls(publication)

  return (
    <DashboardModuleListItem title={title}>
      <DashboardModuleListItem.TertiaryText>
        # {id}
      </DashboardModuleListItem.TertiaryText>

      <DashboardModuleListItem.Actions>
        <DashboardModuleListItem.Icon
          marginRight="medium"
          onClick={() => confirmDelete(updateServiceProduct, togglePublication)}
          type="delete"
        />

        <DashboardModuleListItem.Icon
          href={`${editPublicationUrl}?redirect=${generateRedirectUrl()}`}
          type="link"
        />
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

EditorialPublicationListItem.propTypes = {
  callbacks: PropTypes.object.isRequired,
  publication: PropTypes.object.isRequired,
}

export default EditorialPublicationListItem
